var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSatelliteDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_12953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7867 32.0977L24.9867 24.8977M36.9867 27.2977C36.9867 23.4786 35.4696 19.8159 32.7691 17.1154C30.0685 14.4149 26.4058 12.8977 22.5867 12.8977M46.5867 27.2977C46.5867 20.9325 44.0582 14.828 39.5573 10.3272C35.0564 5.82629 28.9519 3.29773 22.5867 3.29773M5.78496 20.0977C3.82763 23.4459 3.03489 27.3483 3.53069 31.1948C4.02649 35.0412 5.78288 38.615 8.52526 41.3574C11.2676 44.0998 14.8414 45.8562 18.6879 46.352C22.5344 46.8478 26.4368 46.0551 29.785 44.0977L5.78496 20.0977Z",
    stroke: "url(#paint0_linear_1560_12953)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_12953",
    x1: 24.9867,
    y1: 3.29773,
    x2: 24.9867,
    y2: 46.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_12953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.897705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteDish);
export default __webpack_public_path__ + "static/media/Satellite-dish.2a6f12cb17f2bd356e96c3997d46a4bc.svg";
export { ForwardRef as ReactComponent };